import {AmsListItemBase} from './AmsListItemBase';
import * as XCol from '../../framework.core/XExportColumn';

export class AmsUserListItem extends AmsListItemBase {
    id: string = '';
    amsID: string = '';
    userID: string = '';
    passWord: string = '';
    name: string = '';
    email: string = '';
    amsSubGroup: string = '';
    agentId: number|null = null;
    active: boolean|null = null;
    amsGroupId: number|null = null;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true, filterable: false }),
        XCol.Create({ col: 1, text: 'User ID', width: 80, dataIndex: 'id', align: XCol.XAlignType.Right, hiddenInColumnSetup: true }),
        XCol.Create({ col: 2, text: 'SCAC', width: 60, dataIndex: 'amsID'}),
        XCol.Create({ col: 3, text: 'User', width: 100, dataIndex: 'userID', defaultColumnFocus : true}),
        XCol.Create({ col: 4, text: 'Password', width: 80, dataIndex: 'passWord'}),
        XCol.Create({ col: 5, text: 'User Name', width: 120, dataIndex: 'name'}),
        XCol.Create({ col: 6, text: 'Email', width: 200, dataIndex: 'email'}),
        XCol.Create({ col: 7, text: 'Branch', width: 60, dataIndex: 'amsSubGroup'}),
        XCol.Create({ col: 8, text: 'Agent ID', width: 100, dataIndex: 'agentId'}),
        XCol.Create({ col: 9, text: 'Inactive', width: 60, dataIndex: 'active', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: AmsUserListItem.prototype.id, orderByAscending: false };

    public static formatData(data: AmsUserListItem[]) {
        return data.map((d: AmsUserListItem) => ({
          ...d,
        }));
    }

}
